import DialogInOne from "src/components/DialogInOne";
import { GroupSetting } from "../types/GetAllRes";

function GroupSettingDialog(props: {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  groupSetting: GroupSetting | undefined;
}) {
  const { title, isOpen, onClose, groupSetting } = props;

  if (!groupSetting) return null;

  return (
    <DialogInOne
      self={{ open: isOpen, onClose }}
      title={title}
      content={
        <div
          style={{
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            fontFamily: "monospace",
          }}
        >
          {JSON.stringify(groupSetting, null, 2)}
        </div>
      }
      isConfirmHidden
      onConfirm={() => {}}
      onCancel={onClose}
      maxWidth="md"
    />
  );
}

export default GroupSettingDialog;
